<template>
  <div class="container flip-clock">
    <template v-for="data in timeData">
      <span
        v-bind:key="data.label"
        class="flip-clock__piece"
        :id="data.elementId"
      >
        <span class="flip-clock__card flip-card">
          <b class="flip-card__top">{{ data.current | twoDigits }}</b>
          <b
            class="flip-card__bottom"
            v-bind:data-value="data.current | twoDigits"
          ></b>
          <b
            class="flip-card__back"
            v-bind:data-value="data.previous | twoDigits"
          ></b>
          <b
            class="flip-card__back-bottom"
            v-bind:data-value="data.previous | twoDigits"
          ></b>
        </span>
        <span class="flip-clock__slot">{{ data.label }}</span>
      </span>
    </template>
  </div>
</template>

<script>
import uuidv4 from "uuid/v4";

const interval = null;
export default {
  name: "flipCountdown",
  interval: 0,
  props: {
    labels: {
      type: Object,
      required: false,
      default: function () {
        return {
          hours: "Stunden",
          minutes: "Minuten",
          seconds: "Sekunden",
        };
      },
    },
  },
  data() {
    const uuid = uuidv4();
    const distance = this.computCountdown();
    const seconds = Math.trunc(distance) % 60;
    const minutes = Math.trunc(distance / 60) % 60;
    const hours = Math.trunc(distance / 60 / 60) % 24;
    return {
      distance: distance,
      timeData: [
        {
          current: hours,
          previous: hours,
          label: this.labels.hours,
          elementId: "flip-card-hours-" + uuid,
        },
        {
          current: minutes,
          previous: minutes,
          label: this.labels.minutes,
          elementId: "flip-card-minutes-" + uuid,
        },
        {
          current: seconds,
          previous: seconds,
          label: this.labels.seconds,
          elementId: "flip-card-seconds-" + uuid,
        },
      ],
    };
  },
  created() {
    this.interval = setInterval(() => {
      this.distance = this.computCountdown();
    }, 1000);
  },
  computed: {
    seconds() {
      return Math.trunc(this.distance) % 60;
    },
    minutes() {
      return Math.trunc(this.distance / 60) % 60;
    },
    hours() {
      return Math.trunc(this.distance / 60 / 60) % 24;
    },
  },
  watch: {
    hours(value) {
      this.updateTime(0, value);
    },
    minutes(value) {
      this.updateTime(1, value);
    },
    seconds(value) {
      this.updateTime(2, value);
    },
  },
  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return "0" + value.toString();
      }
      return value.toString();
    },
  },
  methods: {
    computCountdown() {
      const now = new Date();
      const startOfNextDay = new Date(now);
      startOfNextDay.setHours(0, 0, 0, 0);
      startOfNextDay.setDate(startOfNextDay.getDate() + 1);

      return (startOfNextDay.getTime() - now.getTime()) / 1000;
    },

    updateTime(idx, newValue) {
      if (idx >= this.timeData.length || newValue === undefined) {
        return;
      }
      if (window["requestAnimationFrame"]) {
        this.frame = requestAnimationFrame(this.updateTime.bind(this));
      }
      const d = this.timeData[idx];
      const val = newValue < 0 ? 0 : newValue;
      const el = document.querySelector(`#${d.elementId}`);
      if (val !== d.current) {
        d.previous = d.current;
        d.current = val;
        if (el) {
          el.classList.remove("flip");
          void el.offsetWidth;
          el.classList.add("flip");
        }
        if (idx === 0) {
          const els = el.querySelectorAll("span b");
          if (els) {
            for (const e of els) {
              const cls = e.classList[0];
              if (newValue / 1000 >= 1) {
                if (!cls.includes("-4digits")) {
                  const newCls = cls + "-4digits";
                  e.classList.add(newCls);
                  e.classList.remove(cls);
                }
              } else {
                if (cls.includes("-4digits")) {
                  const newCls = cls.replace("-4digits", "");
                  e.classList.add(newCls);
                  e.classList.remove(cls);
                }
              }
            }
          }
        }
      }
    },
  },
  beforeDestroy() {
    if (window["cancelAnimationFrame"]) {
      cancelAnimationFrame(this.frame);
    }
  },
  destroyed() {
    clearInterval(interval);
  },
};
</script>

<style scoped lang="scss">
@import "../../node_modules/bootstrap/scss/functions";
@import "../../node_modules/bootstrap/scss/variables";
@import "../../node_modules/bootstrap/scss/mixins";

.flip-clock {
  text-align: center;
  perspective: 400px;
  margin: 0 auto;
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
}
.flip-clock__piece {
  display: inline-block;
  margin: 0 0.2vw;
  @media (min-width: 1000px) {
    margin: 0 5px;
  }
}
.flip-clock__slot {
  font-size: 0.5rem;
  line-height: 1.5;
  display: block;
}
$halfHeight: 0.72em;
$borderRadius: 0.15em;
.flip-card {
  display: block;
  position: relative;
  padding-bottom: $halfHeight;
  font-size: 2.25rem;
  line-height: 0.95;
}
@media (min-width: 1000px) {
  .flip-clock__slot {
    font-size: 1rem;
  }
  .flip-card {
    font-size: 2rem;
  }
}
.flip-card__top,
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__back::before,
.flip-card__back::after {
  display: block;
  height: $halfHeight;
  color: theme-color("light");
  background: theme-color("primary");
  padding: 0.23em 0.15em 0.4em;
  border-radius: $borderRadius $borderRadius 0 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;
  width: 2.1em;
  height: $halfHeight;
}
.flip-card__top-4digits,
.flip-card__bottom-4digits,
.flip-card__back-bottom-4digits,
.flip-card__back-4digits::before,
.flip-card__back-4digits::after {
  display: block;
  height: $halfHeight;
  color: theme-color("light");
  background: theme-color("primary");
  padding: 0.23em 0.15em 0.4em;
  border-radius: $borderRadius $borderRadius 0 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform-style: preserve-3d;
  width: 2.65em;
  height: $halfHeight;
}
.flip-card__bottom,
.flip-card__back-bottom,
.flip-card__bottom-4digits,
.flip-card__back-bottom-4digits {
  color: lighten(theme-color("light"), 20%);
  position: absolute;
  top: 50%;
  left: 0;
  border-top: solid 1px darken(theme-color("primary"), 10%);
  background: lighten(theme-color("primary"), 10%);
  border-radius: 0 0 $borderRadius $borderRadius;
  pointer-events: none;
  overflow: hidden;
  z-index: 2;
}
.flip-card__back-bottom,
.flip-card__back-bottom-4digits {
  z-index: 1;
}
.flip-card__bottom::after,
.flip-card__back-bottom::after,
.flip-card__bottom-4digits::after,
.flip-card__back-bottom-4digits::after {
  display: block;
  margin-top: -$halfHeight;
}
.flip-card__back::before,
.flip-card__bottom::after,
.flip-card__back-bottom::after,
.flip-card__back-4digits::before,
.flip-card__bottom-4digits::after,
.flip-card__back-bottom-4digits::after {
  content: attr(data-value);
}
.flip-card__back,
.flip-card__back-4digits {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0%;
  pointer-events: none;
}
.flip-card__back::before,
.flip-card__back-4digits::before {
  position: relative;
  overflow: hidden;
  z-index: -1;
}
.flip .flip-card__back::before,
.flip .flip-card__back-4digits::before {
  z-index: 1;
  animation: flipTop 0.3s cubic-bezier(0.37, 0.01, 0.94, 0.35);
  animation-fill-mode: both;
  transform-origin: center bottom;
}
.flip .flip-card__bottom,
.flip .flip-card__bottom-4digits {
  transform-origin: center top;
  animation-fill-mode: both;
  animation: flipBottom 0.6s cubic-bezier(0.15, 0.45, 0.28, 1);
}
@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 2;
  }
  0%,
  99% {
    opacity: 1;
  }
  100% {
    transform: rotateX(-90deg);
    opacity: 0;
  }
}
@keyframes flipBottom {
  0%,
  50% {
    z-index: -1;
    transform: rotateX(90deg);
    opacity: 0;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    transform: rotateX(0deg);
    z-index: 5;
  }
}
</style>
